import $ from 'jquery';
import Tooltip from 'tether-tooltip';

export default function tooltip(selector) {
  const $tooltip = $(selector);

  $tooltip.each((index, element) => {
    const $item = $(element);
    const content = $item.data('tooltip') || $item.attr('title');

    // to stop the page to error if no attribut is found
    if (!content) {
      return;
    }

    $item.removeAttr('title');

    // eslint-disable-next-line no-new
    const instance = new Tooltip({
      classes: 'netc-tooltip-theme',
      constrainToWindow: true,
      content,
      position: 'top right',
      target: $item[0],
      openOn: 'focus',
      tetherOptions: {
        constraints: [
          {
            to: 'scrollParent',
            attachment: 'together',
            pin: true,
          },
        ],
      },
    });

    if ($item.is(':focus')) {
      instance.open();
    }
  });
}
